module.exports=function(scope){ return `// Override application language with the selected locale
[Zoom.sdk setLanguage:@"fr"];
`};


// WEBPACK FOOTER //
// ./src/resources/code/ios/21-localization-setlanguage.m.tpl